import type {
  CarFilterOption,
  CarFilters,
  MultiValueFilter,
  SingleValueFilter,
} from '@/scopes/checkout/filterableCars/domain/types';
import {
  defaultSelected
} from '@/scopes/checkout/filterableCars/infrastructure/api/filter-mappers/singleValueFilterMapper';

export const selectedFiltersSelector = (filters?: CarFilters): Record<string, string[]> | null => {
  if (!filters || Object.keys(filters).length === 0) return null;

  return Object.entries(filters).reduce<Record<string, string[]>>((acc, [key, filter]: [string, SingleValueFilter & MultiValueFilter]) => {
    const selectedFilterName = filter.selectedFilter
      ? filter.filterOptions.find((option: CarFilterOption) => (filter.selectedFilter !== defaultSelected && option.value === filter.selectedFilter))?.name
      : null;

    const selectedFiltersNames = filter.selectedFilters
      ? filter.filterOptions
        .filter((option: CarFilterOption) => filter.selectedFilters.includes(option.value))
        .map((option: CarFilterOption) => option.name)
      : [];

    const allSelected = [
      ...(selectedFilterName ? [selectedFilterName] : []),
      ...selectedFiltersNames,
    ];

    if (allSelected.length > 0) {
      acc[key] = allSelected;
    }

    return acc;
  }, {});
};
